// // src/pages/client/Messages.jsx
// import React, { useState, useEffect, useRef } from 'react';
// import './Messaging.scss';
// import withAuth from '../../auth/WithAuth';
// import Sidebar from '../../../components/layout/Sidebar';
// import { serverUrlAuth } from '../../../serverUrl';
// import { toast } from 'react-toastify';

// import {
//   FaSearch,
//   FaUserCircle,
//   FaComments,
//   FaPaperPlane,
//   FaArrowLeft,
//   FaCheckDouble,
//   FaClock,
//   FaCheck,
//   FaHandshake,
//   FaMoneyBillWave,
//   FaCheckCircle,
//   FaFlag,
//   FaWallet,
//   FaRocket,
//   FaLock,
// } from 'react-icons/fa';

// import { useLocation, useNavigate } from 'react-router-dom';
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';

// const Messages = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const queryParams = new URLSearchParams(location.search);
//   const preselectedProposalId = queryParams.get('proposal');

//   // ============================================================
//   // STATE
//   // ============================================================
//   const [conversations, setConversations] = useState([]);
//   const [selectedConversation, setSelectedConversation] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState('');

//   const [loading, setLoading] = useState(true);
//   const [isSending, setIsSending] = useState(false);

//   // Loader flag for the chat area.
//   // true  → loader
//   // false → messages (or "no messages")
//   const [isLoadingChat, setIsLoadingChat] = useState(false);

//   const [searchTerm, setSearchTerm] = useState('');
//   const [showSidebar, setShowSidebar] = useState(true);

//   const [negotiationDetails, setNegotiationDetails] = useState(null);
//   const [userRole, setUserRole] = useState(null);

//   const [acceptingOffer, setAcceptingOffer] = useState(false);
//   const [projectStatus, setProjectStatus] = useState(null);
//   const [currentProjectId, setCurrentProjectId] = useState(null);
//   const [selectingArtisan, setSelectingArtisan] = useState(false);
//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [depositAmount, setDepositAmount] = useState(0);
//   const [finalAgreedAmount, setFinalAgreedAmount] = useState(0);

//   const [showFinalAgreementModal, setShowFinalAgreementModal] =
//     useState(false);
//   const [finalAgreementAmount, setFinalAgreementAmount] = useState('');
//   const [isSubmittingFinalAgreement, setIsSubmittingFinalAgreement] =
//     useState(false);

//   const messagesEndRef = useRef(null);
//   const messageIntervalRef = useRef(null);
//   const messagesContainerRef = useRef(null);
//   const isPollingRef = useRef(false);

//   const activeProposalRef = useRef(null);
//   const activeProjectRef = useRef(null);

//   // Stale-response guards
//   const conversationTokenRef = useRef(0);
//   const abortControllerRef = useRef(null);

//   // ============================================================
//   // DERIVED STATE
//   // ============================================================
//   const isNegotiationActive = negotiationDetails?.is_selected === true;

//   const isNegotiationClosed =
//     !isNegotiationActive && negotiationDetails?.is_closed === true;

//   const isChatDisabled = isNegotiationClosed;

//   // ============================================================
//   // PROJECT STATUS HELPERS
//   // ============================================================
//   const isAwaitingDeposit = (status) => {
//     if (!status) return false;
//     const s = String(status).toLowerCase();
//     return (
//       s === 'awaiting-deposit-payment' ||
//       s === 'awaiting deposit payment' ||
//       s === 'awaiting-final-payment' ||
//       s === 'awaiting final payment'
//     );
//   };

//   const hasPaymentSystemMessage = messages.some(
//     (msg) =>
//       msg.type === 'system' &&
//       msg.message?.includes('DEPOSIT PAYMENT REQUIRED'),
//   );

//   // ============================================================
//   // BODY / MOBILE
//   // ============================================================
//   useEffect(() => {
//     document.body.classList.add('artisan-messages-active');
//     return () =>
//       document.body.classList.remove('artisan-messages-active');
//   }, []);

//   useEffect(() => {
//     if (selectedConversation) {
//       document.body.classList.add('chat-open');
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.classList.remove('chat-open');
//       document.body.style.overflow = '';
//     }
//     return () => {
//       document.body.classList.remove('chat-open');
//       document.body.style.overflow = '';
//     };
//   }, [selectedConversation]);

//   // ============================================================
//   // MARK CONVERSATION AS READ
//   // ============================================================
//   const markConversationAsRead = async (
//     projectId,
//     negotiationId,
//     refreshInbox = true,
//   ) => {
//     if (!projectId || !negotiationId) return;

//     try {
//       await serverUrlAuth.post(
//         `/updates/mark-messages-as-read/${projectId}/${negotiationId}/mark-all-read/`,
//       );

//       if (refreshInbox) {
//         const convResponse = await serverUrlAuth.get(
//           'negotiations/inbox/',
//         );
//         setConversations(
//           Array.isArray(convResponse.data) ? convResponse.data : [],
//         );
//       }
//     } catch (err) {
//       console.error(
//         'Error marking conversation as read:',
//         err.response?.data || err,
//       );
//     }
//   };

//   // ============================================================
//   // USER ROLE
//   // ============================================================
//   const fetchUserRole = async () => {
//     try {
//       const response = await serverUrlAuth.get('users/profile/');
//       const role =
//         response.data.role ||
//         response.data.user_role ||
//         response.data.user_type;
//       setUserRole(role);
//       return role;
//     } catch (err) {
//       console.error('Error fetching user role:', err);
//       return null;
//     }
//   };

//   // ============================================================
//   // PROJECT STATUS
//   // ============================================================
//   const fetchProjectStatus = async (projectId) => {
//     if (!projectId) return null;
//     try {
//       const response = await serverUrlAuth.get(
//         `projects/client-project/${projectId}/`,
//       );
//       setProjectStatus(response.data?.status || null);
//       return response.data?.status || null;
//     } catch (err) {
//       console.error('Error fetching project status:', err);
//       return null;
//     }
//   };

//   // ============================================================
//   // NEGOTIATION DETAILS
//   // ============================================================
//   const fetchNegotiationDetails = async (proposalId) => {
//     if (!proposalId) return null;

//     try {
//       const response = await serverUrlAuth.get(
//         `negotiations/proposal/${proposalId}/`,
//       );

//       if (
//         activeProposalRef.current &&
//         String(activeProposalRef.current) !== String(proposalId)
//       ) {
//         return null;
//       }

//       const details = response.data;
//       setNegotiationDetails(details);

//       if (details.final_agreed_amount) {
//         const amount = Number(details.final_agreed_amount);
//         setFinalAgreedAmount(amount);
//         setDepositAmount(amount * 0.5);
//       } else {
//         setFinalAgreedAmount(0);
//         setDepositAmount(0);
//       }

//       if (details.proposal_details?.project) {
//         setCurrentProjectId(details.proposal_details.project);
//       }

//       return details;
//     } catch (err) {
//       console.error('Error fetching negotiation details:', err);
//       return null;
//     }
//   };

//   // ============================================================
//   // FETCH MESSAGES
//   // ============================================================
//   //
//   // On initial load, setMessages AND setIsLoadingChat(false) are
//   // in the SAME synchronous block → React batches into ONE render.
//   // The loader is replaced by messages directly — no flash.
//   //
//   const fetchMessages = async (
//     projectId,
//     proposalId,
//     isInitialLoad = false,
//     token = null,
//   ) => {
//     if (!projectId || !proposalId) {
//       if (isInitialLoad) setIsLoadingChat(false);
//       return;
//     }

//     const myToken =
//       token !== null ? token : conversationTokenRef.current;

//     if (
//       activeProjectRef.current &&
//       String(activeProjectRef.current) !== String(projectId)
//     ) {
//       if (isInitialLoad) setIsLoadingChat(false);
//       return;
//     }

//     try {
//       let rawMessages = [];

//       if (isNegotiationActive) {
//         const response = await serverUrlAuth.get(
//           `/updates/messages/${projectId}/`,
//           { signal: abortControllerRef.current?.signal },
//         );

//         if (conversationTokenRef.current !== myToken) return;

//         rawMessages = Array.isArray(response.data?.conversation)
//           ? response.data.conversation
//           : Array.isArray(response.data)
//           ? response.data
//           : [];
//       } else {
//         const response = await serverUrlAuth.get(
//           `negotiations/proposal/${proposalId}/messages/`,
//           { signal: abortControllerRef.current?.signal },
//         );

//         if (conversationTokenRef.current !== myToken) return;

//         rawMessages = Array.isArray(response.data)
//           ? response.data
//           : Array.isArray(response.data?.messages)
//           ? response.data.messages
//           : [];
//       }

//       if (conversationTokenRef.current !== myToken) return;

//       const processed = rawMessages
//         .map((msg) => ({
//           ...msg,
//           id: msg.id,
//           message: msg.message || msg.content || '',
//           timestamp: msg.timestamp || msg.created_at,
//           sender_role: msg.sender_role,
//           sender_name: msg.sender_name,
//           sender_id: msg.sender_id || msg.sender,
//           read_by_client: msg.read_by_client,
//           read_by_artisan: msg.read_by_artisan,
//           type: msg.type || 'chat',
//           source: isNegotiationActive ? 'project' : 'negotiation',
//           negotiation_id:
//             msg.negotiation_id || msg.negotiation || null,
//         }))
//         .sort((a, b) => {
//           const dateA = new Date(a.timestamp || 0).getTime();
//           const dateB = new Date(b.timestamp || 0).getTime();
//           return dateA - dateB;
//         });

//       // ✅ ATOMIC SWAP — same synchronous block, one render
//       if (isInitialLoad) {
//         setMessages(processed);
//         setIsLoadingChat(false);
//         setTimeout(scrollToBottom, 0);
//       } else {
//         setMessages(processed);
//         maybeScrollToBottom();
//       }
//     } catch (err) {
//       if (
//         err.name === 'CanceledError' ||
//         err.code === 'ERR_CANCELED'
//       ) {
//         return;
//       }

//       if (conversationTokenRef.current !== myToken) return;

//       console.error(
//         'Error fetching messages:',
//         err.response?.data || err,
//       );

//       if (isInitialLoad) {
//         // Defer the loader-off so a retry or a subsequent render
//         // can populate messages first.
//         setTimeout(() => {
//           if (conversationTokenRef.current === myToken) {
//             setMessages([]);
//             setIsLoadingChat(false);
//           }
//         }, 800);
//         toast.error('Failed to load messages');
//       }
//     }
//   };

//   // ============================================================
//   // FETCH CONVERSATIONS
//   // ============================================================
//   const fetchConversations = async () => {
//     try {
//       const response = await serverUrlAuth.get(
//         'negotiations/inbox/',
//       );
//       const data = Array.isArray(response.data)
//         ? response.data
//         : [];
//       setConversations(data);

//       if (!userRole && data.length > 0) {
//         setUserRole('client');
//       }

//       if (preselectedProposalId && !selectedConversation) {
//         const conversation = data.find(
//           (c) =>
//             c.proposal?.toString() ===
//             preselectedProposalId.toString(),
//         );

//         if (conversation) {
//           await handleSelectConversation(conversation, true);
//         } else {
//           await fetchSingleConversation(preselectedProposalId);
//         }
//       }
//     } catch (err) {
//       console.error('Error fetching conversations:', err);
//       toast.error('Failed to load conversations');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ============================================================
//   // FETCH SINGLE CONVERSATION (deep link)
//   // ============================================================
//   const fetchSingleConversation = async (proposalId) => {
//     if (!proposalId) return;

//     stopPolling();
//     if (abortControllerRef.current) {
//       abortControllerRef.current.abort();
//       abortControllerRef.current = null;
//     }

//     conversationTokenRef.current += 1;
//     const myToken = conversationTokenRef.current;

//     setIsLoadingChat(true);
//     setMessages([]);
//     setNegotiationDetails(null);
//     setProjectStatus(null);
//     setFinalAgreedAmount(0);
//     setDepositAmount(0);

//     try {
//       const response = await serverUrlAuth.get(
//         `negotiations/proposal/${proposalId}/`,
//       );

//       if (conversationTokenRef.current !== myToken) return;

//       const convData = response.data;
//       const projectId = convData.proposal_details?.project;
//       const negotiationId = convData.id;

//       const newConversation = {
//         id: negotiationId,
//         proposal: proposalId,
//         project_id: projectId,
//         project_title: convData.project_title,
//         artisan_name: convData.artisan_name,
//         client_name: convData.client_name,
//         last_message_time: convData.created_at,
//         unread_count: 0,
//         is_closed: convData.is_closed,
//         is_selected: convData.is_selected,
//       };

//       activeProposalRef.current = proposalId;
//       activeProjectRef.current = projectId;

//       setSelectedConversation(newConversation);
//       setCurrentProjectId(projectId);
//       setShowSidebar(false);
//       setNegotiationDetails(convData);

//       abortControllerRef.current = new AbortController();

//       await fetchMessages(projectId, proposalId, true, myToken);

//       if (conversationTokenRef.current !== myToken) return;

//       fetchProjectStatus(projectId);

//       if (negotiationId) {
//         await markConversationAsRead(
//           projectId,
//           negotiationId,
//           true,
//         );
//       }
//     } catch (err) {
//       if (conversationTokenRef.current !== myToken) return;
//       console.error('Error fetching single conversation:', err);
//       toast.error('Could not open conversation');

//       // Defer loader-off so a subsequent retry can populate first
//       setTimeout(() => {
//         if (conversationTokenRef.current === myToken) {
//           setIsLoadingChat(false);
//         }
//       }, 1500);
//     }
//   };

//   // ============================================================
//   // SELECT CONVERSATION
//   // ============================================================
//   const handleSelectConversation = async (
//     conversation,
//     fromPreselection = false,
//   ) => {
//     stopPolling();
//     if (abortControllerRef.current) {
//       abortControllerRef.current.abort();
//       abortControllerRef.current = null;
//     }

//     conversationTokenRef.current += 1;
//     const myToken = conversationTokenRef.current;

//     // Show loader & reset messages in one batch
//     setIsLoadingChat(true);
//     setMessages([]);
//     setNewMessage('');
//     setNegotiationDetails(null);
//     setProjectStatus(null);
//     setFinalAgreedAmount(0);
//     setDepositAmount(0);
//     setSelectedConversation(conversation);

//     const proposalId = conversation.proposal;
//     const projectId =
//       conversation.proposal_details?.project ||
//       conversation.project_id;

//     if (!proposalId) {
//       toast.error('Could not identify this conversation.');
//       setTimeout(() => {
//         if (conversationTokenRef.current === myToken) {
//           setIsLoadingChat(false);
//         }
//       }, 800);
//       return;
//     }

//     activeProposalRef.current = proposalId;
//     activeProjectRef.current = projectId;

//     setCurrentProjectId(projectId);
//     setShowSidebar(false);

//     if (!fromPreselection) {
//       const params = new URLSearchParams(location.search);
//       params.set('proposal', proposalId);
//       navigate(`${location.pathname}?${params.toString()}`, {
//         replace: true,
//       });
//     }

//     try {
//       abortControllerRef.current = new AbortController();

//       const negotiation = await fetchNegotiationDetails(proposalId);

//       if (conversationTokenRef.current !== myToken) return;

//       if (!negotiation) {
//         toast.error('Could not load conversation');
//         setTimeout(() => {
//           if (conversationTokenRef.current === myToken) {
//             setIsLoadingChat(false);
//           }
//         }, 800);
//         return;
//       }

//       await fetchMessages(projectId, proposalId, true, myToken);

//       if (conversationTokenRef.current !== myToken) return;

//       fetchProjectStatus(projectId);

//       if (negotiation?.id) {
//         await markConversationAsRead(
//           projectId,
//           negotiation.id,
//           true,
//         );
//       }
//     } catch (err) {
//       if (conversationTokenRef.current !== myToken) return;
//       console.error('Error selecting conversation:', err);
//       toast.error('Failed to load conversation');

//       // ✅ Defer loader-off — polling will retry silently first
//       setTimeout(() => {
//         if (conversationTokenRef.current === myToken) {
//           setIsLoadingChat(false);
//         }
//       }, 1500);
//     }
//   };

//   // ============================================================
//   // SEND MESSAGE
//   // ============================================================
//   const handleSendMessage = async () => {
//     if (isChatDisabled) {
//       toast.info('This conversation is closed.');
//       return;
//     }

//     if (!newMessage.trim() || !selectedConversation || isSending)
//       return;

//     const messageText = newMessage.trim();
//     setIsSending(true);

//     const myToken = conversationTokenRef.current;

//     const tempMessage = {
//       id: `temp-${Date.now()}`,
//       message: messageText,
//       sender_role: userRole || 'client',
//       timestamp: new Date().toISOString(),
//       temp_sent: true,
//       read_by_client: false,
//       read_by_artisan: false,
//       type: 'chat',
//     };

//     setMessages((prev) => [...prev, tempMessage]);
//     setNewMessage('');
//     scrollToBottom();

//     try {
//       let response;

//       if (isNegotiationActive && currentProjectId) {
//         const formData = new FormData();
//         formData.append('type', 'chat');
//         formData.append('message', messageText);

//         response = await serverUrlAuth.post(
//           `/updates/post-updates/${currentProjectId}/`,
//           formData,
//           // { headers: { 'Content-Type': 'multipart/form-data' } },
//         );
//       } else {
//         response = await serverUrlAuth.post(
//           `negotiations/proposal/${selectedConversation.proposal}/messages/`,
//           { message: messageText },
//         );
//       }

//       if (conversationTokenRef.current === myToken) {
//         setMessages((prev) =>
//           prev.map((msg) =>
//             msg.id === tempMessage.id ? response.data : msg,
//           ),
//         );
//       }

//       const convResponse = await serverUrlAuth.get(
//         'negotiations/inbox/',
//       );

//       if (conversationTokenRef.current === myToken) {
//         setConversations(
//           Array.isArray(convResponse.data)
//             ? convResponse.data
//             : [],
//         );
//       }
//     } catch (err) {
//       if (conversationTokenRef.current === myToken) {
//         setMessages((prev) =>
//           prev.filter((msg) => msg.id !== tempMessage.id),
//         );
//       }

//       console.error('Failed to send message:', err);

//       if (
//         err.response?.data?.detail ===
//         'Your message contains restricted content and cannot be delivered.'
//       ) {
//         toast.error(
//           '⚠️ Message blocked: Contains restricted content (phone numbers, emails)',
//         );
//       } else {
//         toast.error('Failed to send message.');
//       }
//     } finally {
//       setIsSending(false);
//     }
//   };

//   // ============================================================
//   // SYSTEM MESSAGE
//   // ============================================================
//   const sendSystemMessage = async (projectId, message) => {
//     if (!projectId) return null;
//     try {
//       const formData = new FormData();
//       formData.append('type', 'system');
//       formData.append('message', message);
//       formData.append('sender_role', 'system');

//       const response = await serverUrlAuth.post(
//         `/updates/post-updates/${projectId}/`,
//         formData,
//       );

//       await fetchMessages(
//         projectId,
//         selectedConversation?.proposal,
//         false,
//         conversationTokenRef.current,
//       );
//       return response.data;
//     } catch (err) {
//       console.error('Error sending system message:', err);
//       return null;
//     }
//   };

//   // ============================================================
//   // SELECT ARTISAN
//   // ============================================================
//   const handleSelectArtisanFromMessages = async () => {
//     if (!selectedConversation?.proposal) return;

//     setSelectingArtisan(true);

//     try {
//       await serverUrlAuth.patch(
//         `proposals/${selectedConversation.proposal}/select/`,
//       );

//       toast.success(
//         `🎉 You have selected ${
//           selectedConversation?.artisan_name || 'the artisan'
//         } for your project!`,
//         { duration: 5000 },
//       );

//       const updatedNegotiation =
//         await fetchNegotiationDetails(
//           selectedConversation.proposal,
//         );

//       await fetchProjectStatus(currentProjectId);

//       const selectedAmount =
//         Number(updatedNegotiation?.final_agreed_amount) ||
//         Number(finalAgreedAmount) ||
//         0;

//       if (selectedAmount > 0) {
//         setFinalAgreedAmount(selectedAmount);
//         const calculatedDeposit = selectedAmount * 0.5;
//         setDepositAmount(calculatedDeposit);

//         const depositFormatted =
//           Number(calculatedDeposit).toLocaleString();
//         const finalFormatted =
//           Number(selectedAmount).toLocaleString();
//         const artisanName =
//           selectedConversation?.artisan_name || 'the artisan';

//         const systemMessage = `💰 **DEPOSIT PAYMENT REQUIRED**

// 🎯 You've selected **${artisanName}** for your project!

// 📊 **Payment Summary:**
// • Total Budget: KSh ${finalFormatted}
// • Deposit Required (50%): KSh ${depositFormatted}

// ⚠️ **Important:**
// The project cannot start until the deposit is paid.

// 📌 **Next Steps:**
// 1️⃣ Click the "Pay Deposit" button below
// 2️⃣ You'll be redirected to your projects page
// 3️⃣ Complete the deposit payment

// Need help? Contact our support team.`;

//         await sendSystemMessage(
//           currentProjectId,
//           systemMessage,
//         );
//       }

//       const convResponse = await serverUrlAuth.get(
//         'negotiations/inbox/',
//       );
//       setConversations(
//         Array.isArray(convResponse.data)
//           ? convResponse.data
//           : [],
//       );

//       await fetchMessages(
//         currentProjectId,
//         selectedConversation?.proposal,
//         false,
//         conversationTokenRef.current,
//       );

//       if (updatedNegotiation?.id) {
//         await markConversationAsRead(
//           currentProjectId,
//           updatedNegotiation.id,
//           true,
//         );
//       }

//       setShowPaymentModal(true);
//     } catch (err) {
//       console.error('Error selecting artisan:', err);
//       toast.error('Failed to select artisan. Please try again.');
//     } finally {
//       setSelectingArtisan(false);
//     }
//   };

//   // ============================================================
//   // NAVIGATION
//   // ============================================================
//   const handleGoToProjects = () => {
//     document.body.style.overflow = 'auto';
//     document.documentElement.style.overflow = 'auto';
//     navigate('/projects');
//   };

//   const handleBackToDashboard = () => {
//     navigate('/client-dashboard');
//   };

//   // ============================================================
//   // SUBMIT FINAL AGREEMENT
//   // ============================================================
//   const handleSubmitFinalAgreement = async () => {
//     if (
//       !finalAgreementAmount ||
//       !selectedConversation ||
//       !negotiationDetails
//     )
//       return;

//     setIsSubmittingFinalAgreement(true);

//     try {
//       await serverUrlAuth.patch(
//         `negotiations/submit-final-agreement/${negotiationDetails.id}/`,
//         { final_agreed_amount: finalAgreementAmount },
//       );

//       toast.success(
//         'Final agreement submitted! Waiting for client acceptance.',
//       );

//       setShowFinalAgreementModal(false);
//       setFinalAgreementAmount('');

//       await fetchNegotiationDetails(
//         selectedConversation.proposal,
//       );
//       await fetchMessages(
//         currentProjectId,
//         selectedConversation.proposal,
//         false,
//         conversationTokenRef.current,
//       );
//     } catch (err) {
//       console.error('Error submitting final agreement:', err);
//       toast.error('Failed to submit final agreement');
//     } finally {
//       setIsSubmittingFinalAgreement(false);
//     }
//   };

//   // ============================================================
//   // ACCEPT FINAL AGREEMENT
//   // ============================================================
//   const handleAcceptFinalAgreement = async () => {
//     if (!negotiationDetails?.pending_final_amount) return;

//     setAcceptingOffer(true);

//     try {
//       await serverUrlAuth.patch(
//         `negotiations/accept-final-agreement/${negotiationDetails.id}/`,
//       );

//       const acceptedAmount = Number(
//         negotiationDetails.pending_final_amount,
//       );

//       toast.success(
//         `✅ Price agreed! You have accepted KSh ${acceptedAmount.toLocaleString()}. Now select the artisan to start the project.`,
//         { duration: 6000 },
//       );

//       setNegotiationDetails((prev) => ({
//         ...prev,
//         final_agreed_amount:
//           negotiationDetails.pending_final_amount,
//         pending_final_amount: null,
//       }));

//       setFinalAgreedAmount(acceptedAmount);
//       setDepositAmount(acceptedAmount * 0.5);

//       await fetchNegotiationDetails(
//         selectedConversation.proposal,
//       );
//       await fetchMessages(
//         currentProjectId,
//         selectedConversation.proposal,
//         false,
//         conversationTokenRef.current,
//       );
//     } catch (err) {
//       console.error('Error accepting agreement:', err);
//       toast.error('Failed to accept agreement. Please try again.');
//     } finally {
//       setAcceptingOffer(false);
//     }
//   };

//   // ============================================================
//   // SCROLL
//   // ============================================================
//   const scrollToBottom = () => {
//     setTimeout(() => {
//       if (messagesContainerRef.current) {
//         messagesContainerRef.current.scrollTop =
//           messagesContainerRef.current.scrollHeight;
//       }
//     }, 100);
//   };

//   const maybeScrollToBottom = () => {
//     setTimeout(() => {
//       const el = messagesContainerRef.current;
//       if (!el) return;

//       const distanceFromBottom =
//         el.scrollHeight - el.scrollTop - el.clientHeight;

//       if (distanceFromBottom < 120) {
//         el.scrollTop = el.scrollHeight;
//       }
//     }, 50);
//   };

//   // ============================================================
//   // POLLING
//   // ============================================================
//   const startPolling = () => {
//     if (messageIntervalRef.current)
//       clearInterval(messageIntervalRef.current);

//     messageIntervalRef.current = setInterval(async () => {
//       if (isNegotiationClosed) return;
//       if (
//         !selectedConversation ||
//         !currentProjectId ||
//         isPollingRef.current
//       )
//         return;

//       const myToken = conversationTokenRef.current;

//       isPollingRef.current = true;

//       try {
//         const proposalId = selectedConversation.proposal;
//         const projectId = currentProjectId;

//         if (!proposalId) return;

//         const negotiation = await fetchNegotiationDetails(
//           proposalId,
//         );

//         if (conversationTokenRef.current !== myToken) return;

//         await fetchMessages(projectId, proposalId, false, myToken);

//         if (conversationTokenRef.current !== myToken) return;

//         const convResponse = await serverUrlAuth.get(
//           'negotiations/inbox/',
//         );

//         if (conversationTokenRef.current !== myToken) return;

//         setConversations(
//           Array.isArray(convResponse.data)
//             ? convResponse.data
//             : [],
//         );

//         fetchProjectStatus(projectId);

//         if (negotiation?.id) {
//           await markConversationAsRead(
//             projectId,
//             negotiation.id,
//             false,
//           );
//         }
//       } catch (error) {
//         if (
//           error.name === 'CanceledError' ||
//           error.code === 'ERR_CANCELED'
//         ) {
//           return;
//         }
//         console.error('Polling error:', error);
//       } finally {
//         isPollingRef.current = false;
//       }
//     }, 5000);
//   };

//   const stopPolling = () => {
//     if (messageIntervalRef.current) {
//       clearInterval(messageIntervalRef.current);
//       messageIntervalRef.current = null;
//     }
//     isPollingRef.current = false;
//   };

//   // ============================================================
//   // FILTER + FORMAT
//   // ============================================================
//   const filteredConversations = conversations.filter(
//     (conv) =>
//       conv.artisan_name
//         ?.toLowerCase()
//         .includes(searchTerm.toLowerCase()) ||
//       conv.client_name
//         ?.toLowerCase()
//         .includes(searchTerm.toLowerCase()) ||
//       conv.project_title
//         ?.toLowerCase()
//         .includes(searchTerm.toLowerCase()),
//   );

//   const formatTime = (timestamp) => {
//     if (!timestamp) return '';
//     const date = new Date(timestamp);
//     const now = new Date();
//     const diff = now - date;
//     const hours = Math.floor(diff / (1000 * 60 * 60));

//     if (hours < 1) {
//       const mins = Math.floor(diff / (1000 * 60));
//       return mins === 0 ? 'Just now' : `${mins} min ago`;
//     }
//     if (hours < 24) {
//       return date.toLocaleTimeString([], {
//         hour: '2-digit',
//         minute: '2-digit',
//       });
//     }
//     if (hours < 48) return 'Yesterday';
//     return date.toLocaleDateString();
//   };

//   const formatMessageTime = (timestamp) => {
//     if (!timestamp) return '';
//     return new Date(timestamp).toLocaleTimeString([], {
//       hour: '2-digit',
//       minute: '2-digit',
//     });
//   };

//   const getUnreadCount = (conversation) =>
//     Number(conversation.unread_count || 0);

//   const effectiveUserRole = userRole || 'client';
//   const effectiveIsClient = effectiveUserRole === 'client';

//   const getDisplayName = (conversation) => {
//     if (!conversation) return 'User';
//     if (effectiveUserRole === 'client') {
//       return (
//         conversation.artisan_name ||
//         conversation.other_party_name ||
//         'Artisan'
//       );
//     }
//     if (effectiveUserRole === 'artisan') {
//       return (
//         conversation.client_name ||
//         conversation.other_party_name ||
//         'Client'
//       );
//     }
//     return (
//       conversation.artisan_name ||
//       conversation.client_name ||
//       'User'
//     );
//   };

//   // ============================================================
//   // EFFECTS
//   // ============================================================
//   useEffect(() => {
//     fetchUserRole();
//     fetchConversations();
//     return () => stopPolling();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   useEffect(() => {
//     if (
//       selectedConversation &&
//       currentProjectId &&
//       !isNegotiationClosed &&
//       !isLoadingChat
//     ) {
//       startPolling();
//     } else {
//       stopPolling();
//     }
//     return () => stopPolling();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     selectedConversation,
//     currentProjectId,
//     isNegotiationClosed,
//     isNegotiationActive,
//     isLoadingChat,
//   ]);

//   // ============================================================
//   // RENDER
//   // ============================================================
//   return (
//     <div className="modern-dashboard messages-shell">
//       <Sidebar />

//       <div className="messages-page-modern">
//         <div className="messages-container-modern">
//           {/* CONVERSATIONS SIDEBAR */}
//           <div
//             className={`conversations-sidebar-modern ${
//               showSidebar ? 'open' : 'closed'
//             }`}
//           >
//             <div className="sidebar-header-modern">
//               <div className="header-top-modern">
//                 <h2>Messages</h2>
//               </div>

//               <div className="search-bar-modern">
//                 <button
//                   type="button"
//                   className="mobile-back-btn-modern"
//                   onClick={handleBackToDashboard}
//                   aria-label="Back to dashboard"
//                 >
//                   <FaArrowLeft />
//                 </button>

//                 <FaSearch className="search-icon-modern" />

//                 <input
//                   type="text"
//                   placeholder="Search conversations..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                 />
//               </div>
//             </div>

//             <div className="conversations-list-modern">
//               {loading ? (
//                 <div className="loading-state-modern">
//                   <div className="spinner-modern"></div>
//                   <p>Loading conversations...</p>
//                 </div>
//               ) : filteredConversations.length === 0 ? (
//                 <div className="empty-state-modern">
//                   <div className="empty-icon-modern">💬</div>
//                   <h4>No conversations yet</h4>
//                   <p>
//                     When you start a conversation, it will appear
//                     here.
//                   </p>
//                 </div>
//               ) : (
//                 filteredConversations.map((conv) => {
//                   const unreadCount = getUnreadCount(conv);
//                   return (
//                     <div
//                       key={conv.id}
//                       className={`conversation-item-modern ${
//                         selectedConversation?.id === conv.id
//                           ? 'active'
//                           : ''
//                       } ${conv.is_closed ? 'closed' : ''}`}
//                       onClick={() =>
//                         handleSelectConversation(conv)
//                       }
//                     >
//                       <div className="avatar-modern">
//                         <FaUserCircle />
//                       </div>

//                       <div className="conversation-info-modern">
//                         <div className="conversation-header-modern">
//                           <h4>{getDisplayName(conv)}</h4>
//                           <span className="timestamp-modern">
//                             {formatTime(conv.last_message_time)}
//                           </span>
//                         </div>

//                         <div className="conversation-preview-modern">
//                           <p className="project-title-modern">
//                             {conv.project_title}
//                           </p>
//                           {conv.is_closed && (
//                             <span className="closed-badge-mini">
//                               🔒 Closed
//                             </span>
//                           )}
//                         </div>
//                       </div>

//                       {unreadCount > 0 && (
//                         <div className="unread-badge-modern">
//                           {unreadCount}
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })
//               )}
//             </div>
//           </div>

//           {/* CHAT AREA */}
//           <div className="chat-area-modern">
//             {!selectedConversation ? (
//               <div className="no-conversation-selected-modern">
//                 <div className="no-chat-icon-modern">
//                   <FaComments />
//                 </div>
//                 <h3>Select a conversation</h3>
//                 <p>
//                   Choose a chat from the list to start messaging
//                 </p>
//                 <button
//                   className="back-to-chats-btn-modern"
//                   onClick={() => setShowSidebar(true)}
//                 >
//                   Back to Chats
//                 </button>
//               </div>
//             ) : (
//               <>
//                 {/* CHAT HEADER */}
//                 <div className="chat-header-modern">
//                   <button
//                     className="back-button-modern"
//                     onClick={() => {
//                       stopPolling();
//                       if (abortControllerRef.current) {
//                         abortControllerRef.current.abort();
//                         abortControllerRef.current = null;
//                       }
//                       conversationTokenRef.current += 1;

//                       setIsLoadingChat(false);
//                       setShowSidebar(true);
//                       setSelectedConversation(null);
//                       setMessages([]);
//                       setNegotiationDetails(null);
//                       setCurrentProjectId(null);
//                       setProjectStatus(null);
//                       setFinalAgreedAmount(0);
//                       setDepositAmount(0);

//                       activeProposalRef.current = null;
//                       activeProjectRef.current = null;

//                       navigate(location.pathname, {
//                         replace: true,
//                       });
//                     }}
//                   >
//                     <FaArrowLeft />
//                   </button>

//                   <div className="chat-user-info-modern">
//                     <div className="user-avatar-modern">
//                       <FaUserCircle />
//                     </div>
//                     <div className="user-details-modern">
//                       <h3>
//                         {getDisplayName(selectedConversation)}
//                       </h3>
//                       <p className="project-context-modern">
//                         Project:{' '}
//                         {selectedConversation.project_title}
//                       </p>
//                     </div>
//                   </div>
//                 </div>

//                 {/* STATUS BANNER */}
//                 {isNegotiationActive ? (
//                   <div className="status-banner-modern success">
//                     <FaCheckCircle />
//                     <span>
//                       {isAwaitingDeposit(projectStatus)
//                         ? 'Artisan Selected — Awaiting Deposit'
//                         : 'Project In Progress'}
//                     </span>
//                     <small>
//                       {isAwaitingDeposit(projectStatus)
//                         ? 'Pay the deposit to start the project'
//                         : 'Track progress and updates here'}
//                     </small>
//                     {isAwaitingDeposit(projectStatus) &&
//                       effectiveIsClient && (
//                         <button
//                           className="pay-deposit-banner-btn"
//                           onClick={handleGoToProjects}
//                         >
//                           <FaWallet /> Pay Deposit
//                         </button>
//                       )}
//                   </div>
//                 ) : isNegotiationClosed ? (
//                   <div className="status-banner-modern closed">
//                     <FaLock className="status-icon" />
//                     <span>Negotiation Closed</span>
//                     <small>
//                       Another artisan was selected for this
//                       project.
//                     </small>
//                   </div>
//                 ) : (
//                   negotiationDetails && (
//                     <div className="status-banner-modern info">
//                       {negotiationDetails.final_agreed_amount ? (
//                         <>
//                           <FaHandshake />
//                           <span>
//                             Price Agreed: KSh{' '}
//                             {Number(
//                               negotiationDetails.final_agreed_amount,
//                             ).toLocaleString()}
//                           </span>
//                           {effectiveIsClient && (
//                             <button
//                               className="select-artisan-btn-modern"
//                               onClick={
//                                 handleSelectArtisanFromMessages
//                               }
//                               disabled={selectingArtisan}
//                             >
//                               {selectingArtisan
//                                 ? 'Processing...'
//                                 : 'Select This Artisan'}
//                             </button>
//                           )}
//                         </>
//                       ) : negotiationDetails.pending_final_amount ? (
//                         <>
//                           <FaMoneyBillWave />
//                           <span>
//                             Pending Offer: KSh{' '}
//                             {Number(
//                               negotiationDetails.pending_final_amount,
//                             ).toLocaleString()}
//                           </span>
//                           {effectiveIsClient && (
//                             <button
//                               className="accept-offer-btn-modern"
//                               onClick={handleAcceptFinalAgreement}
//                               disabled={acceptingOffer}
//                             >
//                               {acceptingOffer
//                                 ? 'Processing...'
//                                 : 'Accept Offer'}
//                             </button>
//                           )}
//                         </>
//                       ) : (
//                         <>
//                           <FaComments />
//                           <span>
//                             Negotiating - Discuss the price
//                           </span>
//                         </>
//                       )}
//                     </div>
//                   )
//                 )}

//                 {/* MESSAGES */}
//                 <div
//                   className="messages-area-modern"
//                   ref={messagesContainerRef}
//                   key={selectedConversation?.id}
//                 >
//                   {isLoadingChat ? (
//                     <div className="loading-messages-modern">
//                       <div className="spinner-modern"></div>
//                       <p>Loading messages...</p>
//                     </div>
//                   ) : messages.length === 0 ? (
//                     <div className="no-messages-modern">
//                       <div className="no-messages-icon-modern">
//                         💬
//                       </div>
//                       <p>No messages yet</p>
//                       <small>
//                         Send a message to start the conversation
//                       </small>
//                     </div>
//                   ) : (
//                     messages.map((msg, index) => {
//                       const isMilestone =
//                         msg.type === 'milestone';
//                       const isFromArtiza =
//                         msg.type === 'system' ||
//                         msg.sender_role === 'system';
//                       const isSent = effectiveIsClient
//                         ? msg.sender_role === 'client'
//                         : msg.sender_role === 'artisan';

//                       const currentTimestamp =
//                         msg.timestamp || msg.created_at;
//                       const previousTimestamp =
//                         messages[index - 1]?.timestamp ||
//                         messages[index - 1]?.created_at;

//                       const showDate =
//                         index === 0 ||
//                         (messages[index - 1] &&
//                           new Date(
//                             currentTimestamp,
//                           ).toDateString() !==
//                             new Date(
//                               previousTimestamp,
//                             ).toDateString());

//                       return (
//                         <React.Fragment
//                           key={msg.id || `msg-${index}`}
//                         >
//                           {showDate && (
//                             <div className="date-divider-modern">
//                               <span>
//                                 {new Date(
//                                   currentTimestamp,
//                                 ).toLocaleDateString(
//                                   undefined,
//                                   {
//                                     weekday: 'long',
//                                     year: 'numeric',
//                                     month: 'long',
//                                     day: 'numeric',
//                                   },
//                                 )}
//                               </span>
//                             </div>
//                           )}

//                           {isFromArtiza ? (
//                             <div className="system-message-modern">
//                               <div className="system-message-content">
//                                 <div className="system-message-header">
//                                   <FaRocket className="system-icon-modern" />
//                                   <span className="system-name-modern">
//                                     Artiza
//                                   </span>
//                                 </div>
//                                 <div className="system-message-body">
//                                   <p className="system-message-text">
//                                     {msg.message}
//                                   </p>
//                                 </div>
//                               </div>
//                             </div>
//                           ) : (
//                             <div
//                               className={`message-bubble-modern ${
//                                 isSent ? 'sent' : 'received'
//                               }`}
//                             >
//                               <div className="message-content-modern">
//                                 {isMilestone ? (
//                                   <div className="milestone-update-modern">
//                                     <div className="milestone-header-modern">
//                                       <FaFlag className="milestone-icon-modern" />
//                                       <span className="milestone-label-modern">
//                                         Milestone Update
//                                       </span>
//                                     </div>
//                                     <div className="progress-section-modern">
//                                       <div className="progress-info-modern">
//                                         <span>
//                                           Progress:{' '}
//                                           {msg.progress_percentage}
//                                           %
//                                         </span>
//                                       </div>
//                                       <div className="progress-bar-container-modern">
//                                         <div
//                                           className="progress-fill-modern"
//                                           style={{
//                                             width: `${msg.progress_percentage}%`,
//                                           }}
//                                         />
//                                       </div>
//                                     </div>
//                                     <div className="milestone-note-modern">
//                                       {msg.note}
//                                     </div>
//                                   </div>
//                                 ) : (
//                                   <p>{msg.message}</p>
//                                 )}

//                                 {msg.offer && (
//                                   <div
//                                     className={`offer-bubble-modern ${
//                                       msg.is_accepted
//                                         ? 'accepted'
//                                         : ''
//                                     }`}
//                                   >
//                                     {msg.is_accepted ? (
//                                       <>
//                                         <FaCheckCircle />{' '}
//                                         Accepted: KSh{' '}
//                                         {Number(
//                                           msg.offer,
//                                         ).toLocaleString()}
//                                       </>
//                                     ) : (
//                                       <>
//                                         💰 Proposal: KSh{' '}
//                                         {Number(
//                                           msg.offer,
//                                         ).toLocaleString()}
//                                       </>
//                                     )}
//                                   </div>
//                                 )}

//                                 {msg.images &&
//                                   msg.images.length > 0 && (
//                                     <div className="message-images-modern">
//                                       {msg.images.map(
//                                         (img, imgIndex) => (
//                                           <img
//                                             key={
//                                               img.id ||
//                                               imgIndex
//                                             }
//                                             src={
//                                               img.image_url ||
//                                               img.image
//                                             }
//                                             alt="Attachment"
//                                             className="message-image-modern"
//                                           />
//                                         ),
//                                       )}
//                                     </div>
//                                   )}
//                               </div>

//                               <div className="message-meta-modern">
//                                 <span className="message-time-modern">
//                                   {formatMessageTime(
//                                     currentTimestamp,
//                                   )}
//                                 </span>
//                                 {isSent && (
//                                   <span className="read-status-modern">
//                                     {msg.read_by_client &&
//                                     msg.read_by_artisan ? (
//                                       <FaCheckDouble />
//                                     ) : (
//                                       <FaCheck />
//                                     )}
//                                   </span>
//                                 )}
//                               </div>
//                             </div>
//                           )}
//                         </React.Fragment>
//                       );
//                     })
//                   )}
//                   <div ref={messagesEndRef} />
//                 </div>

//                 {/* INPUT */}
//                 {isNegotiationClosed ? (
//                   <div className="message-input-area-modern">
//                     <div className="closed-chat-banner">
//                       <div className="closed-icon">🔒</div>
//                       <div className="closed-text">
//                         <strong>
//                           This conversation is closed
//                         </strong>
//                         <span>
//                           Another artisan was selected for this
//                           project. You can no longer send or
//                           receive messages here.
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="message-input-area-modern">
//                     <div className="input-wrapper-modern">
//                       <input
//                         type="text"
//                         placeholder={
//                           isLoadingChat
//                             ? 'Loading conversation...'
//                             : 'Type a message...'
//                         }
//                         value={newMessage}
//                         onChange={(e) =>
//                           setNewMessage(e.target.value)
//                         }
//                         onKeyPress={(e) => {
//                           if (
//                             e.key === 'Enter' &&
//                             !e.shiftKey
//                           ) {
//                             e.preventDefault();
//                             handleSendMessage();
//                           }
//                         }}
//                         className="message-input-modern"
//                         disabled={isLoadingChat}
//                       />
//                       <button
//                         onClick={handleSendMessage}
//                         disabled={
//                           !newMessage.trim() ||
//                           isSending ||
//                           isLoadingChat
//                         }
//                         className="send-button-modern"
//                       >
//                         {isSending ? (
//                           <FaClock />
//                         ) : (
//                           <FaPaperPlane />
//                         )}
//                       </button>
//                     </div>

//                     {hasPaymentSystemMessage &&
//                       effectiveIsClient && (
//                         <button
//                           className="pay-deposit-btn-modern"
//                           onClick={handleGoToProjects}
//                         >
//                           <FaWallet />
//                           <span>Pay Deposit</span>
//                         </button>
//                       )}
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* FINAL AGREEMENT MODAL */}
//       <Modal
//         show={showFinalAgreementModal}
//         onHide={() => setShowFinalAgreementModal(false)}
//         centered
//         className="price-modal-modern"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Submit Final Agreement</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="price-modal-content-modern">
//             <p>
//               Submit the final agreed price for this project.
//             </p>
//             <div className="price-input-group-modern">
//               <label>Final Agreed Amount (KSh)</label>
//               <input
//                 type="number"
//                 placeholder="Enter final agreed amount"
//                 value={finalAgreementAmount}
//                 onChange={(e) =>
//                   setFinalAgreementAmount(e.target.value)
//                 }
//               />
//             </div>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             variant="secondary"
//             onClick={() => setShowFinalAgreementModal(false)}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             onClick={handleSubmitFinalAgreement}
//             disabled={
//               !finalAgreementAmount || isSubmittingFinalAgreement
//             }
//           >
//             {isSubmittingFinalAgreement
//               ? 'Submitting...'
//               : 'Submit Agreement'}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* PAYMENT MODAL */}
//       <Modal
//         show={showPaymentModal}
//         onHide={() => setShowPaymentModal(false)}
//         centered
//         className="payment-info-modal-modern"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>💰 Deposit Payment Required</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="payment-info-content-modern">
//             <div className="payment-success-icon-modern">
//               <FaCheckCircle className="success-icon-modern" />
//             </div>
//             <h4>Artisan Selected Successfully!</h4>
//             <p>
//               You have selected{' '}
//               <strong>
//                 {selectedConversation?.artisan_name}
//               </strong>{' '}
//               for your project.
//             </p>

//             <div className="payment-details-modern">
//               <div className="payment-detail-item-modern">
//                 <span>Total Budget:</span>
//                 <strong>
//                   KSh{' '}
//                   {Number(finalAgreedAmount).toLocaleString()}
//                 </strong>
//               </div>
//             </div>

//             <div className="payment-info-notice-modern">
//               <FaWallet className="notice-icon-modern" />
//               <p>
//                 <strong>
//                   ⚠️ Deposit Payment Required to Start Project
//                 </strong>
//                 <br />
//                 To proceed with this project, you need to pay the
//                 deposit of{' '}
//                 <strong>
//                   KSh {Number(depositAmount).toLocaleString()}
//                 </strong>
//                 .
//                 <br />
//                 <br />
//                 Click the button below to go to your projects
//                 page and complete the payment.
//                 <br />
//                 <small className="payment-note-modern">
//                   💡 The artisan will start working on your
//                   project only after the deposit is confirmed.
//                 </small>
//               </p>
//             </div>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             variant="secondary"
//             onClick={() => setShowPaymentModal(false)}
//           >
//             Close
//           </Button>
//           <Button
//             variant="primary"
//             onClick={handleGoToProjects}
//             className="goto-projects-btn-modal-modern"
//           >
//             <FaWallet className="me-2" />
//             Proceed To Projects Page
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default withAuth(Messages, 'client');


// src/pages/client/Messages.jsx
import React, { useState, useEffect, useRef } from 'react';
import './Messaging.scss';
import withAuth from '../../auth/WithAuth';
import Sidebar from '../../../components/layout/Sidebar';
import { serverUrlAuth } from '../../../serverUrl';
import { toast } from 'react-toastify';

import {
  FaSearch,
  FaUserCircle,
  FaComments,
  FaPaperPlane,
  FaArrowLeft,
  FaCheckDouble,
  FaClock,
  FaCheck,
  FaHandshake,
  FaMoneyBillWave,
  FaCheckCircle,
  FaFlag,
  FaWallet,
  FaRocket,
  FaLock,
} from 'react-icons/fa';

import { useLocation, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const Messages = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const preselectedProposalId = queryParams.get('proposal');

  // ============================================================
  // STATE
  // ============================================================
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');

  const [loading, setLoading] = useState(true);
  const [isSending, setIsSending] = useState(false);

  const [isLoadingChat, setIsLoadingChat] = useState(false);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');
  const [showSidebar, setShowSidebar] = useState(true);

  const [negotiationDetails, setNegotiationDetails] = useState(null);
  const [userRole, setUserRole] = useState(null);

  const [acceptingOffer, setAcceptingOffer] = useState(false);
  const [projectStatus, setProjectStatus] = useState(null);
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [selectingArtisan, setSelectingArtisan] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [depositAmount, setDepositAmount] = useState(0);
  const [finalAgreedAmount, setFinalAgreedAmount] = useState(0);

  const [showFinalAgreementModal, setShowFinalAgreementModal] =
    useState(false);
  const [finalAgreementAmount, setFinalAgreementAmount] = useState('');
  const [isSubmittingFinalAgreement, setIsSubmittingFinalAgreement] =
    useState(false);

  const messagesEndRef = useRef(null);
  const messageIntervalRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const isPollingRef = useRef(false);

  const activeProposalRef = useRef(null);
  const activeProjectRef = useRef(null);

  const conversationTokenRef = useRef(0);
  const abortControllerRef = useRef(null);

  // ✅ NEW: per-proposal phase cache.
  //    Maps proposalId (string) → boolean (isNegotiationActive).
  //    Primed from the inbox response, updated whenever fresh
  //    negotiation details are fetched. This decouples the
  //    endpoint choice from React state timing.
  const proposalPhaseRef = useRef(new Map());

  // ============================================================
  // DERIVED STATE
  // ============================================================
  const isNegotiationActive = negotiationDetails?.is_selected === true;

  const isNegotiationClosed =
    !isNegotiationActive && negotiationDetails?.is_closed === true;

  const isChatDisabled = isNegotiationClosed;

  // Helper: consult the cache first, then fall back to state.
  const resolvePhase = (proposalId) => {
    if (!proposalId) return false;

    const cached = proposalPhaseRef.current.get(String(proposalId));
    if (typeof cached === 'boolean') return cached;

    return isNegotiationActive;
  };

  // ============================================================
  // PROJECT STATUS HELPERS
  // ============================================================
  const isAwaitingDeposit = (status) => {
    if (!status) return false;
    const s = String(status).toLowerCase();
    return (
      s === 'awaiting-deposit-payment' ||
      s === 'awaiting deposit payment' ||
      s === 'awaiting-final-payment' ||
      s === 'awaiting final payment'
    );
  };

  const hasPaymentSystemMessage = messages.some(
    (msg) =>
      msg.type === 'system' &&
      msg.message?.includes('DEPOSIT PAYMENT REQUIRED'),
  );

  // ============================================================
  // BODY / MOBILE
  // ============================================================
  useEffect(() => {
    document.body.classList.add('artisan-messages-active');
    return () =>
      document.body.classList.remove('artisan-messages-active');
  }, []);

  useEffect(() => {
    if (selectedConversation) {
      document.body.classList.add('chat-open');
      document.body.style.overflow = 'hidden';
    } else {
      document.body.classList.remove('chat-open');
      document.body.style.overflow = '';
    }
    return () => {
      document.body.classList.remove('chat-open');
      document.body.style.overflow = '';
    };
  }, [selectedConversation]);

  // ============================================================
  // MARK CONVERSATION AS READ
  // ============================================================
  const markConversationAsRead = async (
    projectId,
    negotiationId,
    refreshInbox = true,
  ) => {
    if (!projectId || !negotiationId) return;

    try {
      await serverUrlAuth.post(
        `/updates/mark-messages-as-read/${projectId}/${negotiationId}/mark-all-read/`,
      );

      if (refreshInbox) {
        const convResponse = await serverUrlAuth.get(
          'negotiations/inbox/',
        );
        const data = Array.isArray(convResponse.data)
          ? convResponse.data
          : [];

        // ✅ Prime the phase cache from every inbox refresh
        data.forEach((conv) => {
          if (
            conv.proposal != null &&
            typeof conv.is_selected === 'boolean'
          ) {
            proposalPhaseRef.current.set(
              String(conv.proposal),
              conv.is_selected,
            );
          }
        });

        setConversations(data);
      }
    } catch (err) {
      console.error(
        'Error marking conversation as read:',
        err.response?.data || err,
      );
    }
  };

  // ============================================================
  // USER ROLE
  // ============================================================
  const fetchUserRole = async () => {
    try {
      const response = await serverUrlAuth.get('users/profile/');
      const role =
        response.data.role ||
        response.data.user_role ||
        response.data.user_type;
      setUserRole(role);
      return role;
    } catch (err) {
      console.error('Error fetching user role:', err);
      return null;
    }
  };

  // ============================================================
  // PROJECT STATUS
  // ============================================================
  const fetchProjectStatus = async (projectId) => {
    if (!projectId) return null;
    try {
      const response = await serverUrlAuth.get(
        `projects/client-project/${projectId}/`,
      );
      setProjectStatus(response.data?.status || null);
      return response.data?.status || null;
    } catch (err) {
      console.error('Error fetching project status:', err);
      return null;
    }
  };

  // ============================================================
  // NEGOTIATION DETAILS
  // ============================================================
  const fetchNegotiationDetails = async (proposalId) => {
    if (!proposalId) return null;

    try {
      const response = await serverUrlAuth.get(
        `negotiations/proposal/${proposalId}/`,
      );

      if (
        activeProposalRef.current &&
        String(activeProposalRef.current) !== String(proposalId)
      ) {
        return null;
      }

      const details = response.data;

      // ✅ Update the phase cache with the authoritative value
      proposalPhaseRef.current.set(
        String(proposalId),
        details?.is_selected === true,
      );

      setNegotiationDetails(details);

      if (details.final_agreed_amount) {
        const amount = Number(details.final_agreed_amount);
        setFinalAgreedAmount(amount);
        setDepositAmount(amount * 0.5);
      } else {
        setFinalAgreedAmount(0);
        setDepositAmount(0);
      }

      if (details.proposal_details?.project) {
        setCurrentProjectId(details.proposal_details.project);
      }

      return details;
    } catch (err) {
      console.error('Error fetching negotiation details:', err);
      return null;
    }
  };

  // ============================================================
  // FETCH MESSAGES
  // ============================================================
  //
  // ✅ NEW: `phaseOverride` argument.
  //
  //    When provided, it is used directly to decide which endpoint
  //    to hit, bypassing any React state that might still be stale.
  //    When not provided, we fall back to the per-proposal cache,
  //    then finally to the derived state.
  //
  const fetchMessages = async (
    projectId,
    proposalId,
    isInitialLoad = false,
    token = null,
    phaseOverride = null,
  ) => {
    if (!projectId || !proposalId) {
      if (isInitialLoad) {
        setIsLoadingChat(false);
        setHasLoadedOnce(true);
      }
      return;
    }

    const myToken =
      token !== null ? token : conversationTokenRef.current;

    // ✅ Resolve the phase in this priority:
    //    1. Explicit override (fresh from a caller that just fetched it)
    //    2. Per-proposal cache (persists across switches)
    //    3. Derived state (last resort)
    const phaseIsActive =
      phaseOverride !== null
        ? phaseOverride
        : proposalPhaseRef.current.has(String(proposalId))
        ? proposalPhaseRef.current.get(String(proposalId)) === true
        : isNegotiationActive;

    if (
      activeProjectRef.current &&
      String(activeProjectRef.current) !== String(projectId)
    ) {
      if (isInitialLoad) {
        setIsLoadingChat(false);
        setHasLoadedOnce(true);
      }
      return;
    }

    try {
      let rawMessages = [];

      if (phaseIsActive) {
        // ------------------------------------------------
        // ACTIVE PROJECT — combined conversation
        // ------------------------------------------------
        const response = await serverUrlAuth.get(
          `/updates/messages/${projectId}/`,
          { signal: abortControllerRef.current?.signal },
        );

        if (conversationTokenRef.current !== myToken) return;

        rawMessages = Array.isArray(response.data?.conversation)
          ? response.data.conversation
          : Array.isArray(response.data)
          ? response.data
          : [];
      } else {
        // ------------------------------------------------
        // NEGOTIATION PHASE — proposal-scoped messages
        // ------------------------------------------------
        const response = await serverUrlAuth.get(
          `negotiations/proposal/${proposalId}/messages/`,
          { signal: abortControllerRef.current?.signal },
        );

        if (conversationTokenRef.current !== myToken) return;

        rawMessages = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data?.messages)
          ? response.data.messages
          : [];
      }

      if (conversationTokenRef.current !== myToken) return;

      const processed = rawMessages
        .map((msg) => ({
          ...msg,
          id: msg.id,
          message: msg.message || msg.content || '',
          timestamp: msg.timestamp || msg.created_at,
          sender_role: msg.sender_role,
          sender_name: msg.sender_name,
          sender_id: msg.sender_id || msg.sender,
          read_by_client: msg.read_by_client,
          read_by_artisan: msg.read_by_artisan,
          type: msg.type || 'chat',
          source: phaseIsActive ? 'project' : 'negotiation',
          negotiation_id:
            msg.negotiation_id || msg.negotiation || null,
        }))
        .sort((a, b) => {
          const dateA = new Date(a.timestamp || 0).getTime();
          const dateB = new Date(b.timestamp || 0).getTime();
          return dateA - dateB;
        });

      if (isInitialLoad) {
        setMessages(processed);
        setIsLoadingChat(false);
        setHasLoadedOnce(true);
        setTimeout(scrollToBottom, 0);
      } else {
        setMessages(processed);
        maybeScrollToBottom();
      }
    } catch (err) {
      if (
        err.name === 'CanceledError' ||
        err.code === 'ERR_CANCELED'
      ) {
        return;
      }

      if (conversationTokenRef.current !== myToken) return;

      console.error(
        'Error fetching messages:',
        err.response?.data || err,
      );

      if (isInitialLoad) {
        setTimeout(() => {
          if (conversationTokenRef.current === myToken) {
            setMessages([]);
            setIsLoadingChat(false);
            setHasLoadedOnce(true);
          }
        }, 800);
        toast.error('Failed to load messages');
      }
    }
  };

  // ============================================================
  // FETCH CONVERSATIONS
  // ============================================================
  const fetchConversations = async () => {
    try {
      const response = await serverUrlAuth.get(
        'negotiations/inbox/',
      );
      const data = Array.isArray(response.data)
        ? response.data
        : [];

      // ✅ Prime the phase cache for every conversation
      data.forEach((conv) => {
        if (
          conv.proposal != null &&
          typeof conv.is_selected === 'boolean'
        ) {
          proposalPhaseRef.current.set(
            String(conv.proposal),
            conv.is_selected,
          );
        }
      });

      setConversations(data);

      if (!userRole && data.length > 0) {
        setUserRole('client');
      }

      if (preselectedProposalId && !selectedConversation) {
        const conversation = data.find(
          (c) =>
            c.proposal?.toString() ===
            preselectedProposalId.toString(),
        );

        if (conversation) {
          await handleSelectConversation(conversation, true);
        } else {
          await fetchSingleConversation(preselectedProposalId);
        }
      }
    } catch (err) {
      console.error('Error fetching conversations:', err);
      toast.error('Failed to load conversations');
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // FETCH SINGLE CONVERSATION (deep link)
  // ============================================================
  const fetchSingleConversation = async (proposalId) => {
    if (!proposalId) return;

    stopPolling();
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }

    conversationTokenRef.current += 1;
    const myToken = conversationTokenRef.current;

    setIsLoadingChat(true);
    setHasLoadedOnce(false);
    setMessages([]);
    setNegotiationDetails(null);
    setProjectStatus(null);
    setFinalAgreedAmount(0);
    setDepositAmount(0);

    try {
      const response = await serverUrlAuth.get(
        `negotiations/proposal/${proposalId}/`,
      );

      if (conversationTokenRef.current !== myToken) return;

      const convData = response.data;
      const projectId = convData.proposal_details?.project;
      const negotiationId = convData.id;

      // ✅ Update cache from fresh data
      proposalPhaseRef.current.set(
        String(proposalId),
        convData.is_selected === true,
      );

      const newConversation = {
        id: negotiationId,
        proposal: proposalId,
        project_id: projectId,
        project_title: convData.project_title,
        artisan_name: convData.artisan_name,
        client_name: convData.client_name,
        last_message_time: convData.created_at,
        unread_count: 0,
        is_closed: convData.is_closed,
        is_selected: convData.is_selected,
      };

      activeProposalRef.current = proposalId;
      activeProjectRef.current = projectId;

      setSelectedConversation(newConversation);
      setCurrentProjectId(projectId);
      setShowSidebar(false);
      setNegotiationDetails(convData);

      abortControllerRef.current = new AbortController();

      // ✅ Pass phase explicitly — the initial fetch hits the right
      //    endpoint immediately.
      await fetchMessages(
        projectId,
        proposalId,
        true,
        myToken,
        convData.is_selected === true,
      );

      if (conversationTokenRef.current !== myToken) return;

      fetchProjectStatus(projectId);

      if (negotiationId) {
        await markConversationAsRead(
          projectId,
          negotiationId,
          true,
        );
      }
    } catch (err) {
      if (conversationTokenRef.current !== myToken) return;
      console.error('Error fetching single conversation:', err);
      toast.error('Could not open conversation');

      setTimeout(() => {
        if (conversationTokenRef.current === myToken) {
          setIsLoadingChat(false);
          setHasLoadedOnce(true);
        }
      }, 1500);
    }
  };

  // ============================================================
  // SELECT CONVERSATION
  // ============================================================
  const handleSelectConversation = async (
    conversation,
    fromPreselection = false,
  ) => {
    stopPolling();
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }

    conversationTokenRef.current += 1;
    const myToken = conversationTokenRef.current;

    setIsLoadingChat(true);
    setHasLoadedOnce(false);
    setMessages([]);
    setNewMessage('');
    setNegotiationDetails(null);
    setProjectStatus(null);
    setFinalAgreedAmount(0);
    setDepositAmount(0);
    setSelectedConversation(conversation);

    const proposalId = conversation.proposal;
    const projectId =
      conversation.proposal_details?.project ||
      conversation.project_id;

    if (!proposalId) {
      toast.error('Could not identify this conversation.');
      setTimeout(() => {
        if (conversationTokenRef.current === myToken) {
          setIsLoadingChat(false);
          setHasLoadedOnce(true);
        }
      }, 800);
      return;
    }

    activeProposalRef.current = proposalId;
    activeProjectRef.current = projectId;

    setCurrentProjectId(projectId);
    setShowSidebar(false);

    if (!fromPreselection) {
      const params = new URLSearchParams(location.search);
      params.set('proposal', proposalId);
      navigate(`${location.pathname}?${params.toString()}`, {
        replace: true,
      });
    }

    try {
      abortControllerRef.current = new AbortController();

      // ✅ Use the cached phase immediately so the first fetch
      //    can begin without waiting for details.
      const cachedPhase =
        proposalPhaseRef.current.has(String(proposalId))
          ? proposalPhaseRef.current.get(String(proposalId)) === true
          : null;

      const negotiation = await fetchNegotiationDetails(proposalId);

      if (conversationTokenRef.current !== myToken) return;

      if (!negotiation) {
        toast.error('Could not load conversation');
        setTimeout(() => {
          if (conversationTokenRef.current === myToken) {
            setIsLoadingChat(false);
            setHasLoadedOnce(true);
          }
        }, 800);
        return;
      }

      const isActive = negotiation?.is_selected === true;

      await fetchMessages(
        projectId,
        proposalId,
        true,
        myToken,
        isActive,
      );

      if (conversationTokenRef.current !== myToken) return;

      fetchProjectStatus(projectId);

      if (negotiation?.id) {
        await markConversationAsRead(
          projectId,
          negotiation.id,
          true,
        );
      }
    } catch (err) {
      if (conversationTokenRef.current !== myToken) return;
      console.error('Error selecting conversation:', err);
      toast.error('Failed to load conversation');

      setTimeout(() => {
        if (conversationTokenRef.current === myToken) {
          setIsLoadingChat(false);
          setHasLoadedOnce(true);
        }
      }, 1500);
    }
  };

  // ============================================================
  // SEND MESSAGE
  // ============================================================
  const handleSendMessage = async () => {
    if (isChatDisabled) {
      toast.info('This conversation is closed.');
      return;
    }

    if (!newMessage.trim() || !selectedConversation || isSending)
      return;

    const messageText = newMessage.trim();
    setIsSending(true);

    const myToken = conversationTokenRef.current;

    const tempMessage = {
      id: `temp-${Date.now()}`,
      message: messageText,
      sender_role: userRole || 'client',
      timestamp: new Date().toISOString(),
      temp_sent: true,
      read_by_client: false,
      read_by_artisan: false,
      type: 'chat',
    };

    setMessages((prev) => [...prev, tempMessage]);
    setNewMessage('');
    scrollToBottom();

    // ✅ Resolve phase from the cache — never stale
    const phaseIsActive = resolvePhase(
      selectedConversation.proposal,
    );

    try {
      let response;

      if (phaseIsActive && currentProjectId) {
        const formData = new FormData();
        formData.append('type', 'chat');
        formData.append('message', messageText);

        response = await serverUrlAuth.post(
          `/updates/post-updates/${currentProjectId}/`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } },
        );
      } else {
        response = await serverUrlAuth.post(
          `negotiations/proposal/${selectedConversation.proposal}/messages/`,
          { message: messageText },
        );
      }

      if (conversationTokenRef.current === myToken) {
        setMessages((prev) =>
          prev.map((msg) =>
            msg.id === tempMessage.id ? response.data : msg,
          ),
        );
      }

      const convResponse = await serverUrlAuth.get(
        'negotiations/inbox/',
      );

      if (conversationTokenRef.current === myToken) {
        const data = Array.isArray(convResponse.data)
          ? convResponse.data
          : [];

        // ✅ Refresh cache
        data.forEach((conv) => {
          if (
            conv.proposal != null &&
            typeof conv.is_selected === 'boolean'
          ) {
            proposalPhaseRef.current.set(
              String(conv.proposal),
              conv.is_selected,
            );
          }
        });

        setConversations(data);
      }
    } catch (err) {
      if (conversationTokenRef.current === myToken) {
        setMessages((prev) =>
          prev.filter((msg) => msg.id !== tempMessage.id),
        );
      }

      console.error('Failed to send message:', err);

      if (
        err.response?.data?.detail ===
        'Your message contains restricted content and cannot be delivered.'
      ) {
        toast.error(
          '⚠️ Message blocked: Contains restricted content (phone numbers, emails)',
        );
      } else {
        toast.error('Failed to send message.');
      }
    } finally {
      setIsSending(false);
    }
  };

  // ============================================================
  // SYSTEM MESSAGE
  // ============================================================
  const sendSystemMessage = async (projectId, message) => {
    if (!projectId) return null;
    try {
      const formData = new FormData();
      formData.append('type', 'system');
      formData.append('message', message);
      formData.append('sender_role', 'system');

      const response = await serverUrlAuth.post(
        `/updates/post-updates/${projectId}/`,
        formData,
      );

      await fetchMessages(
        projectId,
        selectedConversation?.proposal,
        false,
        conversationTokenRef.current,
        true,   // system messages only exist in active phase
      );
      return response.data;
    } catch (err) {
      console.error('Error sending system message:', err);
      return null;
    }
  };

  // ============================================================
  // SELECT ARTISAN
  // ============================================================
  const handleSelectArtisanFromMessages = async () => {
    if (!selectedConversation?.proposal) return;

    setSelectingArtisan(true);

    try {
      await serverUrlAuth.patch(
        `proposals/${selectedConversation.proposal}/select/`,
      );

      toast.success(
        `🎉 You have selected ${
          selectedConversation?.artisan_name || 'the artisan'
        } for your project!`,
        { duration: 5000 },
      );

      const updatedNegotiation =
        await fetchNegotiationDetails(
          selectedConversation.proposal,
        );

      await fetchProjectStatus(currentProjectId);

      const selectedAmount =
        Number(updatedNegotiation?.final_agreed_amount) ||
        Number(finalAgreedAmount) ||
        0;

      if (selectedAmount > 0) {
        setFinalAgreedAmount(selectedAmount);
        const calculatedDeposit = selectedAmount * 0.5;
        setDepositAmount(calculatedDeposit);

        const depositFormatted =
          Number(calculatedDeposit).toLocaleString();
        const finalFormatted =
          Number(selectedAmount).toLocaleString();
        const artisanName =
          selectedConversation?.artisan_name || 'the artisan';

        const systemMessage = `💰 **DEPOSIT PAYMENT REQUIRED**

🎯 You've selected **${artisanName}** for your project!

📊 **Payment Summary:**
• Total Budget: KSh ${finalFormatted}
• Deposit Required (50%): KSh ${depositFormatted}

⚠️ **Important:**
The project cannot start until the deposit is paid.

📌 **Next Steps:**
1️⃣ Click the "Pay Deposit" button below
2️⃣ You'll be redirected to your projects page
3️⃣ Complete the deposit payment

Need help? Contact our support team.`;

        await sendSystemMessage(
          currentProjectId,
          systemMessage,
        );
      }

      const convResponse = await serverUrlAuth.get(
        'negotiations/inbox/',
      );
      const data = Array.isArray(convResponse.data)
        ? convResponse.data
        : [];

      // ✅ Refresh cache — this proposal is now selected
      data.forEach((conv) => {
        if (
          conv.proposal != null &&
          typeof conv.is_selected === 'boolean'
        ) {
          proposalPhaseRef.current.set(
            String(conv.proposal),
            conv.is_selected,
          );
        }
      });

      setConversations(data);

      const isActive =
        updatedNegotiation?.is_selected === true ||
        proposalPhaseRef.current.get(
          String(selectedConversation.proposal),
        ) === true;

      await fetchMessages(
        currentProjectId,
        selectedConversation?.proposal,
        false,
        conversationTokenRef.current,
        isActive,
      );

      if (updatedNegotiation?.id) {
        await markConversationAsRead(
          currentProjectId,
          updatedNegotiation.id,
          true,
        );
      }

      setShowPaymentModal(true);
    } catch (err) {
      console.error('Error selecting artisan:', err);
      toast.error('Failed to select artisan. Please try again.');
    } finally {
      setSelectingArtisan(false);
    }
  };

  // ============================================================
  // NAVIGATION
  // ============================================================
  const handleGoToProjects = () => {
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';
    navigate('/projects');
  };

  const handleBackToDashboard = () => {
    navigate('/client-dashboard');
  };

  // ============================================================
  // SUBMIT FINAL AGREEMENT
  // ============================================================
  const handleSubmitFinalAgreement = async () => {
    if (
      !finalAgreementAmount ||
      !selectedConversation ||
      !negotiationDetails
    )
      return;

    setIsSubmittingFinalAgreement(true);

    try {
      await serverUrlAuth.patch(
        `negotiations/submit-final-agreement/${negotiationDetails.id}/`,
        { final_agreed_amount: finalAgreementAmount },
      );

      toast.success(
        'Final agreement submitted! Waiting for client acceptance.',
      );

      setShowFinalAgreementModal(false);
      setFinalAgreementAmount('');

      await fetchNegotiationDetails(
        selectedConversation.proposal,
      );

      await fetchMessages(
        currentProjectId,
        selectedConversation.proposal,
        false,
        conversationTokenRef.current,
        resolvePhase(selectedConversation.proposal),
      );
    } catch (err) {
      console.error('Error submitting final agreement:', err);
      toast.error('Failed to submit final agreement');
    } finally {
      setIsSubmittingFinalAgreement(false);
    }
  };

  // ============================================================
  // ACCEPT FINAL AGREEMENT
  // ============================================================
  const handleAcceptFinalAgreement = async () => {
    if (!negotiationDetails?.pending_final_amount) return;

    setAcceptingOffer(true);

    try {
      await serverUrlAuth.patch(
        `negotiations/accept-final-agreement/${negotiationDetails.id}/`,
      );

      const acceptedAmount = Number(
        negotiationDetails.pending_final_amount,
      );

      toast.success(
        `✅ Price agreed! You have accepted KSh ${acceptedAmount.toLocaleString()}. Now select the artisan to start the project.`,
        { duration: 6000 },
      );

      setNegotiationDetails((prev) => ({
        ...prev,
        final_agreed_amount:
          negotiationDetails.pending_final_amount,
        pending_final_amount: null,
      }));

      setFinalAgreedAmount(acceptedAmount);
      setDepositAmount(acceptedAmount * 0.5);

      await fetchNegotiationDetails(
        selectedConversation.proposal,
      );

      await fetchMessages(
        currentProjectId,
        selectedConversation.proposal,
        false,
        conversationTokenRef.current,
        resolvePhase(selectedConversation.proposal),
      );
    } catch (err) {
      console.error('Error accepting agreement:', err);
      toast.error('Failed to accept agreement. Please try again.');
    } finally {
      setAcceptingOffer(false);
    }
  };

  // ============================================================
  // SCROLL
  // ============================================================
  const scrollToBottom = () => {
    setTimeout(() => {
      if (messagesContainerRef.current) {
        messagesContainerRef.current.scrollTop =
          messagesContainerRef.current.scrollHeight;
      }
    }, 100);
  };

  const maybeScrollToBottom = () => {
    setTimeout(() => {
      const el = messagesContainerRef.current;
      if (!el) return;

      const distanceFromBottom =
        el.scrollHeight - el.scrollTop - el.clientHeight;

      if (distanceFromBottom < 120) {
        el.scrollTop = el.scrollHeight;
      }
    }, 50);
  };

  // ============================================================
  // POLLING
  // ============================================================
  const startPolling = () => {
    if (messageIntervalRef.current)
      clearInterval(messageIntervalRef.current);

    messageIntervalRef.current = setInterval(async () => {
      if (isNegotiationClosed) return;
      if (
        !selectedConversation ||
        !currentProjectId ||
        isPollingRef.current
      )
        return;

      const myToken = conversationTokenRef.current;

      isPollingRef.current = true;

      try {
        const proposalId = selectedConversation.proposal;
        const projectId = currentProjectId;

        if (!proposalId) return;

        const negotiation = await fetchNegotiationDetails(
          proposalId,
        );

        if (conversationTokenRef.current !== myToken) return;

        // ✅ Explicit phase — never stale
        const isActive = negotiation?.is_selected === true;

        await fetchMessages(
          projectId,
          proposalId,
          false,
          myToken,
          isActive,
        );

        if (conversationTokenRef.current !== myToken) return;

        const convResponse = await serverUrlAuth.get(
          'negotiations/inbox/',
        );

        if (conversationTokenRef.current !== myToken) return;

        const data = Array.isArray(convResponse.data)
          ? convResponse.data
          : [];

        // ✅ Keep cache in sync on every poll
        data.forEach((conv) => {
          if (
            conv.proposal != null &&
            typeof conv.is_selected === 'boolean'
          ) {
            proposalPhaseRef.current.set(
              String(conv.proposal),
              conv.is_selected,
            );
          }
        });

        setConversations(data);

        fetchProjectStatus(projectId);

        if (negotiation?.id) {
          await markConversationAsRead(
            projectId,
            negotiation.id,
            false,
          );
        }
      } catch (error) {
        if (
          error.name === 'CanceledError' ||
          error.code === 'ERR_CANCELED'
        ) {
          return;
        }
        console.error('Polling error:', error);
      } finally {
        isPollingRef.current = false;
      }
    }, 5000);
  };

  const stopPolling = () => {
    if (messageIntervalRef.current) {
      clearInterval(messageIntervalRef.current);
      messageIntervalRef.current = null;
    }
    isPollingRef.current = false;
  };

  // ============================================================
  // FILTER + FORMAT
  // ============================================================
  const filteredConversations = conversations.filter(
    (conv) =>
      conv.artisan_name
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      conv.client_name
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      conv.project_title
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()),
  );

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const now = new Date();
    const diff = now - date;
    const hours = Math.floor(diff / (1000 * 60 * 60));

    if (hours < 1) {
      const mins = Math.floor(diff / (1000 * 60));
      return mins === 0 ? 'Just now' : `${mins} min ago`;
    }
    if (hours < 24) {
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
    }
    if (hours < 48) return 'Yesterday';
    return date.toLocaleDateString();
  };

  const formatMessageTime = (timestamp) => {
    if (!timestamp) return '';
    return new Date(timestamp).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getUnreadCount = (conversation) =>
    Number(conversation.unread_count || 0);

  const effectiveUserRole = userRole || 'client';
  const effectiveIsClient = effectiveUserRole === 'client';

  const getDisplayName = (conversation) => {
    if (!conversation) return 'User';
    if (effectiveUserRole === 'client') {
      return (
        conversation.artisan_name ||
        conversation.other_party_name ||
        'Artisan'
      );
    }
    if (effectiveUserRole === 'artisan') {
      return (
        conversation.client_name ||
        conversation.other_party_name ||
        'Client'
      );
    }
    return (
      conversation.artisan_name ||
      conversation.client_name ||
      'User'
    );
  };

  // ============================================================
  // EFFECTS
  // ============================================================
  useEffect(() => {
    fetchUserRole();
    fetchConversations();
    return () => stopPolling();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      selectedConversation &&
      currentProjectId &&
      !isNegotiationClosed &&
      !isLoadingChat
    ) {
      startPolling();
    } else {
      stopPolling();
    }
    return () => stopPolling();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedConversation,
    currentProjectId,
    isNegotiationClosed,
    isNegotiationActive,
    isLoadingChat,
  ]);

  // ============================================================
  // RENDER
  // ============================================================
  return (
    <div className="modern-dashboard messages-shell">
      <Sidebar />

      <div className="messages-page-modern">
        <div className="messages-container-modern">
          {/* CONVERSATIONS SIDEBAR */}
          <div
            className={`conversations-sidebar-modern ${
              showSidebar ? 'open' : 'closed'
            }`}
          >
            <div className="sidebar-header-modern">
              <div className="header-top-modern">
                <h2>Messages</h2>
              </div>

              <div className="search-bar-modern">
                <button
                  type="button"
                  className="mobile-back-btn-modern"
                  onClick={handleBackToDashboard}
                  aria-label="Back to dashboard"
                >
                  <FaArrowLeft />
                </button>

                <FaSearch className="search-icon-modern" />

                <input
                  type="text"
                  placeholder="Search conversations..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <div className="conversations-list-modern">
              {loading ? (
                <div className="loading-state-modern">
                  <div className="spinner-modern"></div>
                  <p>Loading conversations...</p>
                </div>
              ) : filteredConversations.length === 0 ? (
                <div className="empty-state-modern">
                  <div className="empty-icon-modern">💬</div>
                  <h4>No conversations yet</h4>
                  <p>
                    When you start a conversation, it will appear
                    here.
                  </p>
                </div>
              ) : (
                filteredConversations.map((conv) => {
                  const unreadCount = getUnreadCount(conv);
                  return (
                    <div
                      key={conv.id}
                      className={`conversation-item-modern ${
                        selectedConversation?.id === conv.id
                          ? 'active'
                          : ''
                      } ${conv.is_closed ? 'closed' : ''}`}
                      onClick={() =>
                        handleSelectConversation(conv)
                      }
                    >
                      <div className="avatar-modern">
                        <FaUserCircle />
                      </div>

                      <div className="conversation-info-modern">
                        <div className="conversation-header-modern">
                          <h4>{getDisplayName(conv)}</h4>
                          <span className="timestamp-modern">
                            {formatTime(conv.last_message_time)}
                          </span>
                        </div>

                        <div className="conversation-preview-modern">
                          <p className="project-title-modern">
                            {conv.project_title}
                          </p>
                          {conv.is_closed && (
                            <span className="closed-badge-mini">
                              🔒 Closed
                            </span>
                          )}
                        </div>
                      </div>

                      {unreadCount > 0 && (
                        <div className="unread-badge-modern">
                          {unreadCount}
                        </div>
                      )}
                    </div>
                  );
                })
              )}
            </div>
          </div>

          {/* CHAT AREA */}
          <div className="chat-area-modern">
            {!selectedConversation ? (
              <div className="no-conversation-selected-modern">
                <div className="no-chat-icon-modern">
                  <FaComments />
                </div>
                <h3>Select a conversation</h3>
                <p>
                  Choose a chat from the list to start messaging
                </p>
                <button
                  className="back-to-chats-btn-modern"
                  onClick={() => setShowSidebar(true)}
                >
                  Back to Chats
                </button>
              </div>
            ) : (
              <>
                {/* CHAT HEADER */}
                <div className="chat-header-modern">
                  <button
                    className="back-button-modern"
                    onClick={() => {
                      stopPolling();
                      if (abortControllerRef.current) {
                        abortControllerRef.current.abort();
                        abortControllerRef.current = null;
                      }
                      conversationTokenRef.current += 1;

                      setIsLoadingChat(false);
                      setHasLoadedOnce(false);
                      setShowSidebar(true);
                      setSelectedConversation(null);
                      setMessages([]);
                      setNegotiationDetails(null);
                      setCurrentProjectId(null);
                      setProjectStatus(null);
                      setFinalAgreedAmount(0);
                      setDepositAmount(0);

                      activeProposalRef.current = null;
                      activeProjectRef.current = null;

                      navigate(location.pathname, {
                        replace: true,
                      });
                    }}
                  >
                    <FaArrowLeft />
                  </button>

                  <div className="chat-user-info-modern">
                    <div className="user-avatar-modern">
                      <FaUserCircle />
                    </div>
                    <div className="user-details-modern">
                      <h3>
                        {getDisplayName(selectedConversation)}
                      </h3>
                      <p className="project-context-modern">
                        Project:{' '}
                        {selectedConversation.project_title}
                      </p>
                    </div>
                  </div>
                </div>

                {/* STATUS BANNER */}
                {isNegotiationActive ? (
                  <div className="status-banner-modern success">
                    <FaCheckCircle />
                    <span>
                      {isAwaitingDeposit(projectStatus)
                        ? 'Artisan Selected — Awaiting Deposit'
                        : 'Project In Progress'}
                    </span>
                    <small>
                      {isAwaitingDeposit(projectStatus)
                        ? 'Pay the deposit to start the project'
                        : 'Track progress and updates here'}
                    </small>
                    {isAwaitingDeposit(projectStatus) &&
                      effectiveIsClient && (
                        <button
                          className="pay-deposit-banner-btn"
                          onClick={handleGoToProjects}
                        >
                          <FaWallet /> Pay Deposit
                        </button>
                      )}
                  </div>
                ) : isNegotiationClosed ? (
                  <div className="status-banner-modern closed">
                    <FaLock className="status-icon" />
                    <span>Negotiation Closed</span>
                    <small>
                      Another artisan was selected for this
                      project.
                    </small>
                  </div>
                ) : (
                  negotiationDetails && (
                    <div className="status-banner-modern info">
                      {negotiationDetails.final_agreed_amount ? (
                        <>
                          <FaHandshake />
                          <span>
                            Price Agreed: KSh{' '}
                            {Number(
                              negotiationDetails.final_agreed_amount,
                            ).toLocaleString()}
                          </span>
                          {effectiveIsClient && (
                            <button
                              className="select-artisan-btn-modern"
                              onClick={
                                handleSelectArtisanFromMessages
                              }
                              disabled={selectingArtisan}
                            >
                              {selectingArtisan
                                ? 'Processing...'
                                : 'Select This Artisan'}
                            </button>
                          )}
                        </>
                      ) : negotiationDetails.pending_final_amount ? (
                        <>
                          <FaMoneyBillWave />
                          <span>
                            Pending Offer: KSh{' '}
                            {Number(
                              negotiationDetails.pending_final_amount,
                            ).toLocaleString()}
                          </span>
                          {effectiveIsClient && (
                            <button
                              className="accept-offer-btn-modern"
                              onClick={handleAcceptFinalAgreement}
                              disabled={acceptingOffer}
                            >
                              {acceptingOffer
                                ? 'Processing...'
                                : 'Accept Offer'}
                            </button>
                          )}
                        </>
                      ) : (
                        <>
                          <FaComments />
                          <span>
                            Negotiating - Discuss the price
                          </span>
                        </>
                      )}
                    </div>
                  )
                )}

                {/* MESSAGES */}
                <div
                  className="messages-area-modern"
                  ref={messagesContainerRef}
                  key={selectedConversation?.id}
                >
                  {isLoadingChat ? (
                    <div className="loading-messages-modern">
                      <div className="spinner-modern"></div>
                      <p>Loading messages...</p>
                    </div>
                  ) : messages.length > 0 ? (
                    messages.map((msg, index) => {
                      const isMilestone =
                        msg.type === 'milestone';
                      const isFromArtiza =
                        msg.type === 'system' ||
                        msg.sender_role === 'system';
                      const isSent = effectiveIsClient
                        ? msg.sender_role === 'client'
                        : msg.sender_role === 'artisan';

                      const currentTimestamp =
                        msg.timestamp || msg.created_at;
                      const previousTimestamp =
                        messages[index - 1]?.timestamp ||
                        messages[index - 1]?.created_at;

                      const showDate =
                        index === 0 ||
                        (messages[index - 1] &&
                          new Date(
                            currentTimestamp,
                          ).toDateString() !==
                            new Date(
                              previousTimestamp,
                            ).toDateString());

                      return (
                        <React.Fragment
                          key={msg.id || `msg-${index}`}
                        >
                          {showDate && (
                            <div className="date-divider-modern">
                              <span>
                                {new Date(
                                  currentTimestamp,
                                ).toLocaleDateString(
                                  undefined,
                                  {
                                    weekday: 'long',
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                  },
                                )}
                              </span>
                            </div>
                          )}

                          {isFromArtiza ? (
                            <div className="system-message-modern">
                              <div className="system-message-content">
                                <div className="system-message-header">
                                  <FaRocket className="system-icon-modern" />
                                  <span className="system-name-modern">
                                    Artiza
                                  </span>
                                </div>
                                <div className="system-message-body">
                                  <p className="system-message-text">
                                    {msg.message}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div
                              className={`message-bubble-modern ${
                                isSent ? 'sent' : 'received'
                              }`}
                            >
                              <div className="message-content-modern">
                                {isMilestone ? (
                                  <div className="milestone-update-modern">
                                    <div className="milestone-header-modern">
                                      <FaFlag className="milestone-icon-modern" />
                                      <span className="milestone-label-modern">
                                        Milestone Update
                                      </span>
                                    </div>
                                    <div className="progress-section-modern">
                                      <div className="progress-info-modern">
                                        <span>
                                          Progress:{' '}
                                          {msg.progress_percentage}
                                          %
                                        </span>
                                      </div>
                                      <div className="progress-bar-container-modern">
                                        <div
                                          className="progress-fill-modern"
                                          style={{
                                            width: `${msg.progress_percentage}%`,
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="milestone-note-modern">
                                      {msg.note}
                                    </div>
                                  </div>
                                ) : (
                                  <p>{msg.message}</p>
                                )}

                                {msg.offer && (
                                  <div
                                    className={`offer-bubble-modern ${
                                      msg.is_accepted
                                        ? 'accepted'
                                        : ''
                                    }`}
                                  >
                                    {msg.is_accepted ? (
                                      <>
                                        <FaCheckCircle />{' '}
                                        Accepted: KSh{' '}
                                        {Number(
                                          msg.offer,
                                        ).toLocaleString()}
                                      </>
                                    ) : (
                                      <>
                                        💰 Proposal: KSh{' '}
                                        {Number(
                                          msg.offer,
                                        ).toLocaleString()}
                                      </>
                                    )}
                                  </div>
                                )}

                                {msg.images &&
                                  msg.images.length > 0 && (
                                    <div className="message-images-modern">
                                      {msg.images.map(
                                        (img, imgIndex) => (
                                          <img
                                            key={
                                              img.id ||
                                              imgIndex
                                            }
                                            src={
                                              img.image_url ||
                                              img.image
                                            }
                                            alt="Attachment"
                                            className="message-image-modern"
                                          />
                                        ),
                                      )}
                                    </div>
                                  )}
                              </div>

                              <div className="message-meta-modern">
                                <span className="message-time-modern">
                                  {formatMessageTime(
                                    currentTimestamp,
                                  )}
                                </span>
                                {isSent && (
                                  <span className="read-status-modern">
                                    {msg.read_by_client &&
                                    msg.read_by_artisan ? (
                                      <FaCheckDouble />
                                    ) : (
                                      <FaCheck />
                                    )}
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })
                  ) : hasLoadedOnce ? (
                    <div className="no-messages-modern">
                      <div className="no-messages-icon-modern">
                        💬
                      </div>
                      <p>No messages yet</p>
                      <small>
                        Send a message to start the conversation
                      </small>
                    </div>
                  ) : (
                    <div className="loading-messages-modern">
                      <div className="spinner-modern"></div>
                      <p>Loading messages...</p>
                    </div>
                  )}
                  <div ref={messagesEndRef} />
                </div>

                {/* INPUT */}
                {isNegotiationClosed ? (
                  <div className="message-input-area-modern">
                    <div className="closed-chat-banner">
                      <div className="closed-icon">🔒</div>
                      <div className="closed-text">
                        <strong>
                          This conversation is closed
                        </strong>
                        <span>
                          Another artisan was selected for this
                          project. You can no longer send or
                          receive messages here.
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="message-input-area-modern">
                    <div className="input-wrapper-modern">
                      <input
                        type="text"
                        placeholder={
                          isLoadingChat
                            ? 'Loading conversation...'
                            : 'Type a message...'
                        }
                        value={newMessage}
                        onChange={(e) =>
                          setNewMessage(e.target.value)
                        }
                        onKeyPress={(e) => {
                          if (
                            e.key === 'Enter' &&
                            !e.shiftKey
                          ) {
                            e.preventDefault();
                            handleSendMessage();
                          }
                        }}
                        className="message-input-modern"
                        disabled={isLoadingChat}
                      />
                      <button
                        onClick={handleSendMessage}
                        disabled={
                          !newMessage.trim() ||
                          isSending ||
                          isLoadingChat
                        }
                        className="send-button-modern"
                      >
                        {isSending ? (
                          <FaClock />
                        ) : (
                          <FaPaperPlane />
                        )}
                      </button>
                    </div>

                    {hasPaymentSystemMessage &&
                      effectiveIsClient && (
                        <button
                          className="pay-deposit-btn-modern"
                          onClick={handleGoToProjects}
                        >
                          <FaWallet />
                          <span>Pay Deposit</span>
                        </button>
                      )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* FINAL AGREEMENT MODAL */}
      <Modal
        show={showFinalAgreementModal}
        onHide={() => setShowFinalAgreementModal(false)}
        centered
        className="price-modal-modern"
      >
        <Modal.Header closeButton>
          <Modal.Title>Submit Final Agreement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="price-modal-content-modern">
            <p>
              Submit the final agreed price for this project.
            </p>
            <div className="price-input-group-modern">
              <label>Final Agreed Amount (KSh)</label>
              <input
                type="number"
                placeholder="Enter final agreed amount"
                value={finalAgreementAmount}
                onChange={(e) =>
                  setFinalAgreementAmount(e.target.value)
                }
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowFinalAgreementModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmitFinalAgreement}
            disabled={
              !finalAgreementAmount || isSubmittingFinalAgreement
            }
          >
            {isSubmittingFinalAgreement
              ? 'Submitting...'
              : 'Submit Agreement'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* PAYMENT MODAL */}
      <Modal
        show={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        centered
        className="payment-info-modal-modern"
      >
        <Modal.Header closeButton>
          <Modal.Title>💰 Deposit Payment Required</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="payment-info-content-modern">
            <div className="payment-success-icon-modern">
              <FaCheckCircle className="success-icon-modern" />
            </div>
            <h4>Artisan Selected Successfully!</h4>
            <p>
              You have selected{' '}
              <strong>
                {selectedConversation?.artisan_name}
              </strong>{' '}
              for your project.
            </p>

            <div className="payment-details-modern">
              <div className="payment-detail-item-modern">
                <span>Total Budget:</span>
                <strong>
                  KSh{' '}
                  {Number(finalAgreedAmount).toLocaleString()}
                </strong>
              </div>
            </div>

            <div className="payment-info-notice-modern">
              <FaWallet className="notice-icon-modern" />
              <p>
                <strong>
                  ⚠️ Deposit Payment Required to Start Project
                </strong>
                <br />
                To proceed with this project, you need to pay the
                deposit of{' '}
                <strong>
                  KSh {Number(depositAmount).toLocaleString()}
                </strong>
                .
                <br />
                <br />
                Click the button below to go to your projects
                page and complete the payment.
                <br />
                <small className="payment-note-modern">
                  💡 The artisan will start working on your
                  project only after the deposit is confirmed.
                </small>
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowPaymentModal(false)}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleGoToProjects}
            className="goto-projects-btn-modal-modern"
          >
            <FaWallet className="me-2" />
            Proceed To Projects Page
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default withAuth(Messages, 'client');